import { Field, ImageField } from '@sitecore-jss/sitecore-jss-nextjs';

import * as icons from '@gn-audio/icons';

export type TabNavigationItemFields = {
  id: string;
  name?: string;
} & (TextTabNavigationItem | IconTabNavigationItem | ImageTabNavigationItem);

type TabNavigationItemContent = {
  content?: {
    id: string;
  }[];
};

export type TextTabNavigationItem = {
  text?: Field<string>;
} & TabNavigationItemContent;

export type IconTabNavigationItem = {
  text?: Field<string>;
  icon?: Field<keyof typeof icons>;
} & TabNavigationItemContent;

export type ImageTabNavigationItem = {
  text?: Field<string>;
  image?: ImageField;
} & TabNavigationItemContent;

export type TabNavigationItemType = 'text' | 'icon' | 'image';
